
import Vue from 'vue'

export default Vue.extend({
  name: 'XSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
